import React from 'react';
import { Shield } from 'lucide-react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-brand-cream border-t border-brand-light" data-id="element-77">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-78">
        <div className="w-20 h-20 bg-brand-gold rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg" data-id="element-79">
          <Shield className="h-10 w-10 text-white" data-id="element-80" />
        </div>

        <h2 className="font-serif text-3xl font-bold text-brand-dark mb-6" data-id="element-81">
          Garantía de "Cintura Feliz" de 7 Días
        </h2>

        <div className="prose prose-lg mx-auto text-gray-600 mb-10" data-id="element-82">
          <p className="mb-4" data-id="element-83">
            Estoy tan segura de que este protocolo cambiará cómo te sientes, que
            asumo todo el riesgo.
          </p>
          <p className="font-medium text-brand-dark" data-id="element-84">
            Si en 7 días no te sientes más ligera, desinflamada y con más
            energía, envíame un email y te devuelvo cada centavo.
          </p>
          <p className="text-sm mt-6 text-gray-500 italic" data-id="element-85">
            Sin preguntas. Sin letra chica. El riesgo es mío.
          </p>
        </div>

        <Button variant="primary" size="lg" onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} className="font-bold shadow-lg" data-id="element-86">
          Quiero empezar con garantía
          <ArrowRight className="ml-2 h-5 w-5" data-id="element-87" />
        </Button>
      </div>
    </section>;
}